export const isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
export const isServer = !isBrowser;
//# sourceMappingURL=isBrowser.js.map